export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-100">
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 right-0 w-[65%] h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Fashion%20lifestyle%20flat%20lay%20with%20pastel%20sneakers%20oversized%20hoodie%20sunglasses%20and%20tote%20bag%20artistically%20arranged%20on%20warm%20beige%20linen%20surface%2C%20soft%20golden%20afternoon%20light%20from%20left%20window%2C%20gentle%20shadows%20and%20organic%20textures%2C%20editorial%20product%20photography%20with%20airy%20composition%2C%20soft%20mint%20and%20peach%20accent%20colors%2C%20elegant%20relaxed%20aesthetic%20with%20generous%20negative%20space&width=1200&height=800&seq=hero-v2-main-z100&orientation=landscape"
            alt="AllChinaBuy Spreadsheet fashion products and trusted finds collection"
            title="AllChinaBuy Spreadsheet – Best fashion and sneaker finds"
            className="w-full h-full object-cover object-top rounded-bl-[60px]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-100 via-background-100/70 to-transparent rounded-bl-[60px]"></div>
        </div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="w-full md:w-[45%] py-16 md:py-24">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-[1.15] mb-6">
              Best{' '}
              <span className="italic text-primary-600">AllChinaBuy Spreadsheet</span>
              {' '}for Fashion, Sneakers &amp; Designer Finds
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-lg">
              Discover thousands of verified products, trusted sellers, quality-checked items, and the latest spreadsheet finds — all organized in one place.
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
              >
                allchinabuy sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold border-2 border-foreground-300 text-foreground-800 rounded-full hover:border-foreground-500 hover:bg-foreground-50 transition-all whitespace-nowrap cursor-pointer"
              >
                buy it now
                <i className="ri-shopping-bag-line"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8">
              {['Updated Daily', 'Trusted Sellers', 'QC Verified', 'Safe Shopping'].map((badge) => (
                <span key={badge} className="inline-flex items-center gap-1.5 text-xs text-foreground-600 whitespace-nowrap">
                  <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                  {badge}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}